import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class ArsaBildirimAPI extends BaseAPI {
  constructor() {
    const baseUrl =
      environment.API_URL + "ArsaBildirimListe";
    super(baseUrl);
  }

  getArsaBildirimListe(pafta?: string, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
    return this.get("", {params:{ pafta: pafta, ada: ada, parsel: parsel,mahalleKodu: mahalleKodu, caddeSokakKodu: caddeSokakKodu}});

  }
}
export default new ArsaBildirimAPI();
class ArsaBildirimRequest {
  public pafta?: string;
  public ada?: number;
  public parsel?: number;
  public mahalleKodu?: number;
  public caddeSokakKodu?: number;

  constructor(pafta?: string, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
    this.pafta = pafta;
    this.ada = ada;
    this.parsel = parsel;
    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
  }
}
export { ArsaBildirimRequest };
